(() => {
    "use strict";

    angular.module("app").controller("StoppedScreeningsController", StoppedScreeningsController);
    StoppedScreeningsController.$inject = ["infiniteScrollDataSourceFactory", "controllerDecorator", "$location"];
    function StoppedScreeningsController(infiniteScrollDataSourceFactory, controllerDecorator, $location) {
        const $controller = this;

        controllerDecorator.Decorate($controller, ["navigation", "files",]);

        $controller.DataSource = null;

        $controller.SetLoadingState(false);

        const currentPath = $location.path();

        if (currentPath === '/Screenings/ConfirmStopScreening') {
            $controller.confirm = true;
        }
        else {
            $controller.confirm = false;
        }

        $controller.selectAll = false;

        $controller.OpenIvm = openIvm;
        $controller.ToggleAll = toggleAll;
        $controller.AreItemsSelected = areItemsSelected;
        $controller.ConfirmStopScreening = confirmStopScreening;
        $controller.ConfirmSelectedStopScreenings = confirmSelectedStopScreenings;
        $controller.CallStopScreeningsApi = callStopScreeningsApi;
        $controller.ExportDossiers = exportDossiers;

        function openIvm(request) {
            $controller.Navigator.OpenIvm(request.RequestId);
        }

        function toggleAll(){
            if (!$controller.DataSource.Items())
                return;
            $controller.selectAll = !$controller.selectAll;

            for (const element of $controller.DataSource.Items()) {
                element.isSelected = $controller.selectAll;
            }
        }

        function areItemsSelected(){
            if (!$controller.DataSource.Items())
                return false;
            return $controller.DataSource.Items().filter((i) => i.isSelected).length > 0;
        }

        function confirmStopScreening(screening){
            if (!screening)
                return;
            $controller.CallStopScreeningsApi([screening.RequestId]);
        }

        function confirmSelectedStopScreenings(){
            const selectedItems = $controller.DataSource.Items().filter((i) => i.isSelected).map((i) => i.RequestId);
            if (!selectedItems)
                return;
            $controller.CallStopScreeningsApi(selectedItems);
        }

        function callStopScreeningsApi(idStrings){
            $controller.SetLoadingState(true);

            $controller.Api.StopScreenings(
                { idStrings: idStrings },
                () => $controller.DataSource.ResetSearch(),
                null,
                () => $controller.SetLoadingState(false));
        }

        function exportDossiers() {
            $controller.SetLoadingState(true);

            const filter = $controller.DataSource.GetFilter();

            if ($controller.confirm) {
                filter.GetConfirmStopScreenings = true;
                filter.GetStoppedScreenings = false;
            }
            else {
                filter.GetConfirmStopScreenings = false;
                filter.GetStoppedScreenings = true;
            }

            $controller.Api.ScreeningsExporting(
                { Filter: filter },
                $controller.File.saveExport,
                $controller.ShowError,
                () => $controller.SetLoadingState(false)
            );
        }

        function initialize() {
            if ($controller.confirm) {
                $controller.DataSource = infiniteScrollDataSourceFactory.Create($controller.Api.GetScreeningsToStop, (v) => $controller.isLoadingRequests = v);
            }
            else {
                $controller.DataSource = infiniteScrollDataSourceFactory.Create($controller.Api.GetStoppedScreenings, (v) => $controller.isLoadingRequests = v);
            }

            const pageAndSort = $controller.DataSource.GetPageAndSort();

            if (pageAndSort.SortBy.length > 0) {
                $controller.sortType = pageAndSort.SortBy[0].Name;
                $controller.sortReverse = pageAndSort.SortBy[0].IsReverse;
            }
            else {
                $controller.DataSource.ResetSearch();
            }
        }

        initialize();
    }
})();